<template>
  <SimpleTable title="Summary" :rows="summaryRows" class="mb-4">
    <template #header>
      <div class="text-muted">Last checked: {{ formatDate(listing.dateLoaded) }}</div>
    </template>
  </SimpleTable>

  <SimpleTable title="Coordinates" :rows="latlngRows" class="mb-4"/>

  <SimpleTable title="Details" :rows="detailRows" class="mb-4"/>

</template>

<script>
import SimpleTable from "@/components/common/SimpleTable.vue";
import {Listing} from "@/models/Listing";
import {TableBuilder} from "@/components/admin-city/TableBuilder";

export default {
  components: {SimpleTable},
  props: {
    listing: Listing
  },
  computed: {
    summaryRows() {
      const l = this.listing;
      return new TableBuilder()
      .row('Source ID', l.details.id)
      .row('Source', l.listingSource.name)
      .row('Title', l.title)
      .rows;
    },
    detailRows() {
      const {
        host, coHosts, bedrooms, bath, description, images, location, price, propertyType
      } = this.listing.details;
      return new TableBuilder()
      .row('Host', host)
      .row('Co-Hosts', coHosts)
      .row('Bedrooms', bedrooms)
      .row('Bathrooms', bath)
      .row('Description', description)
      .row('Location', location && location.title)
      .row('Neighborhood', location && location.content)
      .row('Price', price)
      .row('Property Type', propertyType)
      .row('Pictures', images, 'images')
      .rows;
    },
    latlngRows() {
      const {lat,lng} = this.listing.latlng;
      return new TableBuilder()
      .row('Latitude', `${lat}° ${lat < 0 ? 'S' : 'N'}`)
      .row('Longitude', `${lng}° ${lng < 0 ? 'W' : 'E'}`)
      .row('Map', {lat,lng}, 'map')
      .rows;
    }
  }
}
</script>
